import styled, { css } from "styled-components";

export const Container = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ isMobile, theme }) =>
    isMobile &&
    css`
      border-top: 1px solid ${theme.colorTokens.border.default};
      background-color: ${theme.colorTokens.background.layer};
    `};
`;
